import { FieldProps } from 'components/mieScommesseTableRow/MieScommesseTableRow';
import styles from './TableField.module.scss';

export const TableField = (props: FieldProps) => {
  const { label, value, className, classNameData, isInColumn, internalClassName } = props;
  return (
    <div
      className={`${styles.fieldContainer} ${isInColumn ? styles.marginBottom : ''} ${
        internalClassName ? styles[internalClassName] : ''
      }`}
    >
      {label && <p className={`${styles.betLabel} ${styles[className!]}`}>{label}</p>}
      <p className={`${styles.betData} ${styles[classNameData!]}`}>{value}</p>
    </div>
  );
};